import type { Id } from '@contracts/common';

/** D91: a mission is opened, and its question answered, on the Nhiệm vụ page. */
export const missionHref = (missionId: Id): string => `/assistant/missions?mission=${encodeURIComponent(missionId)}`;
/** S7 P24: a standing order is reached through the page's orders tab. */
export const ORDERS_HREF = '/assistant/missions?tab=orders';
/** L4 T13: one standing order, picked out on the orders tab (the run log's link to it). */
export const orderHref = (orderId: Id): string => `${ORDERS_HREF}&order=${encodeURIComponent(orderId)}`;
